var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.compList[_vm.compListNumber],{tag:"component",attrs:{"reserveSet":_vm.reserveSet,"reserveList":_vm.reserveList,"reservationList":_vm.reservationList},on:{"next-comp":_vm.nextComp,"back-comp":_vm.backComp,"send-confirmation":_vm.sendConfirmation,"back-firstcomp":_vm.backFirstComp}})
}
var staticRenderFns = []

export { render, staticRenderFns }